import { render, staticRenderFns } from "./ButtonResponseOptionForm.vue?vue&type=template&id=873c5fe8&scoped=true&"
import script from "./ButtonResponseOptionForm.vue?vue&type=script&lang=js&"
export * from "./ButtonResponseOptionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873c5fe8",
  null
  
)

export default component.exports